import { useNavigate } from 'react-router-dom';
import './AuthTypography.css';

export function RegistrationDonePage() {
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate('/login');
  };

  return (
    <div className="auth-page min-h-screen bg-[#fbf7f1] px-6 py-8 text-slate-800 md:px-8 md:py-10">
      <div className="mx-auto flex min-h-[80vh] max-w-5xl items-center justify-center">
        <div className="w-full max-w-[560px] rounded-[28px] border border-[#efe7da] bg-white px-8 py-12 text-center shadow-[0_18px_40px_rgba(19,19,19,0.05)] md:px-12 md:py-14">
          <div className="mx-auto flex h-28 w-28 items-center justify-center rounded-full bg-[#faf6ef]">
            <div className="flex h-14 w-14 items-center justify-center rounded-full border-4 border-[#d2b98b] text-[#d2b98b]">
              <svg viewBox="0 0 24 24" className="h-8 w-8" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M20 6L9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>

          <h1 className="mt-10 text-4xl font-semibold leading-tight text-slate-900">
            Registrierung
            <br />
            erfolgreich!
          </h1>

          <p className="mx-auto mt-8 max-w-[360px] text-[15px] leading-8 text-slate-400">
            Vielen Dank für Ihre Registrierung im Patientenportal. Wir haben Ihnen eine E-Mail mit einem
            Bestätigungslink gesendet.
          </p>

          <button
            type="button"
            onClick={goToDashboard}
            className="mt-10 inline-flex w-full max-w-[420px] items-center justify-center rounded-2xl bg-[#d2b98b] px-8 py-5 text-xl font-semibold text-white shadow-[0_10px_20px_rgba(210,185,139,0.25)]"
          >
            Zum Patientenportal
          </button>
        </div>
      </div>
    </div>
  );
}
